import { apiGet } from './client';
import type { GroupingLevel } from '../types/GroupingLevel';

export function getGroupingLevels(): Promise<GroupingLevel[]> {
  return apiGet<GroupingLevel[]>('/api/grouping-levels');
}
